<form [formGroup]="inputGroup" (submit)="editSubscriptionOption()">
  <div class="row">
    <div class="col-sm-2">
      <label for="text">Message:</label>
    </div>
    <div class="col-sm-10">
      <input id="text" pInputTextarea formControlName="text" />
      <small
        style="color: red"
        *ngIf="!inputGroup.get('text')?.valid && inputGroup.get('text')?.dirty"
        >Please enter subscription option text.</small
      >
    </div>
  </div>

  <div class="clearfix visible-xs"></div>
  <div class="to-right flex">
    <p-button
      label="Cancel"
      styleClass="p-button-danger"
      (onClick)="cancelEditSubscriptionOption()"
    ></p-button>
    <p-button
      label="Edit Subscription Option"
      type="Submit"
      [disabled]="!inputGroup.valid"
    ></p-button>
  </div>
</form>
